"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const SidebarTabs = ({ selectedTab, setSelectedTab }) => ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", gap: 1, mb: 2, children: ["existing", "new"].map((tab) => ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: selectedTab === tab ? "contained" : "outlined", onClick: () => setSelectedTab(tab), size: "small", sx: {
            textTransform: "none",
            fontWeight: "normal",
            flex: 1,
            borderRadius: "8px",
            border: "none",
        }, children: tab === "existing" ? "Existing Form" : "New Form" }, tab))) }));
exports.default = SidebarTabs;
